const AWS = require('aws-sdk')
const moment = require('moment')

const { IMPORT_CSV_S3_BUCKET } = process.env
const { NOWREADY_LOGO_S3_BUCKET } = process.env

const S3_BUCKETS = {
    IMPORT_CSV: "IMPORT_CSV_S3_BUCKET",
    NOWREADY_LOGO: "NOWREADY_LOGO_S3_BUCKET"
}

const buckets = {
    IMPORT_CSV_S3_BUCKET,
    NOWREADY_LOGO_S3_BUCKET
}

class S3 {
    constructor (targetBucketKey) {
        this.s3 = new AWS.S3()
        if(!buckets[targetBucketKey]){
            throw new Error(`Invalid bucket key: ${targetBucketKey}`)
        }
        this.targetBucket = buckets[targetBucketKey]
    }

    uploadFile (file, accountId) {
        // Give unique filename to prevent overwritting existing files
        const formattedFileName = this.formatFileName(file.name, accountId)

        // Setting up S3 upload parameters
        const params = {
            Bucket: this.targetBucket,
            Key: formattedFileName, // File name you want to save as in S3
            Metadata: { accountId },
            Body: file.data
        };

        // Uploading files to the bucket
        return this.s3.upload(params).promise();
    }

    formatFileName (fileName, accountId) {
        const regex = /\s+|\(|\)|\!|\'/g // Select spaces,(,),!,'
        const filenameArray = fileName.split('.')

        const fileFormat = filenameArray.pop()

        const filenameWithoutSpaces = filenameArray
            .join('.') // In cases there's a dot (.) in the filename
            .replace(regex, '-') // Replace spaces,(,),!,' for dashes

        const dateFormatted = moment().format('MMM-DD-hh-mm-ss')

        return `${filenameWithoutSpaces}-${accountId}-${dateFormatted}.${fileFormat}`
    }

    getFile (fileName) {
        const params = {
            Bucket: this.targetBucket,
            Key: fileName, // File name you want to save as in S3
        };

        return this.s3.getObject(params).promise()
    }
}

module.exports = { S3, S3_BUCKETS }